export default "__VITE_ASSET__CGnTFXYH__"